import type {EditMaterialNoteFormPayload} from "./edit-material-note.schema";

import {editMaterialNote} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {materialKeys, materialMutationKeys} from "../../../../../material-keys";

export function editMaterialNoteMutationOptions(id: string, noteId: number) {
  return mutationOptions({
    mutationKey: materialMutationKeys.editMaterialNote,
    mutationFn: (payload: EditMaterialNoteFormPayload) => editMaterialNote(id, noteId, payload),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: materialKeys.detail(id)}),
        client.invalidateQueries({queryKey: materialKeys.lists()}),
      ]);
    },
  });
}
